import {
  Component,
  ChangeDetectionStrategy,
  LOCALE_ID,
  inject,
} from '@angular/core';
import { UAParser } from 'ua-parser-js';

import { ENV_TOKEN } from '@app/app.tokens';
import { Env } from '@app/core/interfaces/env.interface';
import { Store } from '@app/shared/modules/mobile-badge/enums/store.enum';

export enum Platforms {
  Android = 'Android',
  iOs = 'iOS',
  Desktop = 'Desktop',
}

export enum Vendors {
  Samsung = 'Samsung',
  Xiaomi = 'Xiaomi',
  Huawei = 'Huawei',
}

@Component({
  selector: 'mobile-badge-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListComponent {
  localeId = inject(LOCALE_ID);
  private env = inject<Env>(ENV_TOKEN);

  readonly platforms = Platforms;
  readonly deviceInfo = this.getDeviceInfo();
  readonly vendors = Vendors;
  readonly stores = Store;

  get storeUrls(): Env['stores'] {
    return this.env.stores;
  }

  get os(): string {
    return this.getOs();
  }

  get vendor(): Vendors | undefined {
    return this.deviceInfo.device.vendor as Vendors | undefined;
  }

  get appName(): string {
    return this.env.appName;
  }

  onMarketClick(store: Store): void {
    const url = this.storeUrls[store];
    window.open(url, '_blank');
  }

  private getDeviceInfo(): UAParser.IResult {
    const parser = new UAParser();
    return parser.getResult();
  }

  private getOs(): string {
    // Android[-x86]
    if (this.deviceInfo.os.name?.includes('Android')) {
      return this.platforms.Android;
    }

    if (this.deviceInfo.os.name === 'iOS') {
      return this.platforms.iOs;
    }

    return this.platforms.Desktop;
  }
}
